import { isProduction } from '@src/shared/helpers/isProduction';
import { createMachine, interpret, assign } from 'xstate';
export const incomeMachine = createMachine({
    id: 'income',
    initial: 'fields',
    context: {
        income: {
            desired: 0,
            current: 0,
            saved: 0,
            applicationYield: 0,
            passiveYield: 4,
        },
        details: [],
    },
    states: {
        fields: {
            on: {
                UPDATE: {
                    actions: 'assignValue',
                },
                ADD_DETAILS: [
                    {
                        cond: 'shouldSubmit',
                        actions: 'assignDetails',
                    },
                ],
            },
        },
    },
}, {
    actions: {
        assignValue: assign((context, event) => {
            if (event.type !== 'UPDATE')
                return context;
            return Object.assign(Object.assign({}, context), { income: Object.assign(Object.assign({}, context.income), { [event.field]: event.value }) });
        }),
        assignDetails: assign((context, event) => {
            if (event.type !== 'ADD_DETAILS')
                return context;
            return Object.assign(Object.assign({}, context), { details: event.details });
        }),
    },
    guards: {
        shouldSubmit: (context) => Object.values(context.income).every((value) => value > 0),
    },
});
export const incomeStore = interpret(incomeMachine, {
    devTools: !isProduction(),
}).start();
